export function LoadingView({ label = 'Loading your movie…' }: { label?: string }) {
  return <main className="centered"><div className="spinner" aria-hidden="true" /><p role="status">{label}</p></main>;
}

